// A scraped URL becomes a clickable link only when it is one.
//
// website_url and maps_uri come from Places, directories and web search, written with the
// service key. React renders `href={value}` as given and only warns in dev, so a value such as
// `javascript:alert(1)` would execute on click in the owner's session.

export function safeHref(value: string | null | undefined): string | undefined {
  if (value === null || value === undefined || value.trim() === '') return undefined;
  try {
    const url = new URL(value.trim());
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : undefined;
  } catch {
    return undefined;
  }
}
